// src/config/envConfig.ts
export const ENV = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  API_BASE_URL_SANDBOX: import.meta.env.VITE_API_BASE_URL_SANDBOX,
  API_BASE_URL_PRODUCTION: import.meta.env.VITE_API_BASE_URL_PRODUCTION,
  AUTH_BASE_URL: import.meta.env.VITE_AUTH_BASE_URL,
  OTP_BASE_URL: import.meta.env.VITE_OTP_BASE_URL,
  // Company API URLs
  COMPANY_API_URL_SANDBOX: import.meta.env.VITE_COMPANY_API_URL_SANDBOX || 'https://authentication-and-manage-roles-uat.raghavan-7fc.workers.dev',
  COMPANY_API_URL_PRODUCTION: import.meta.env.VITE_COMPANY_API_URL_PRODUCTION || 'https://authentication-and-manage-roles-production.raghavan-7fc.workers.dev',
  LOGIN_ENDPOINT: import.meta.env.VITE_LOGIN_ENDPOINT,
  FORGOT_PASSWORD_ENDPOINT: import.meta.env.VITE_FORGOT_PASSWORD_ENDPOINT,
  RESET_PASSWORD_ENDPOINT: import.meta.env.VITE_RESET_PASSWORD_ENDPOINT,
  UPDATE_PASSWORD_ENDPOINT: import.meta.env.VITE_UPDATE_PASSWORD_ENDPOINT,
  VERIFY_OTP_ENDPOINT: import.meta.env.VITE_VERIFY_OTP_ENDPOINT,
  RESEND_OTP_ENDPOINT: import.meta.env.VITE_RESEND_OTP_ENDPOINT,
  SEND_OTP_ENDPOINT: import.meta.env.VITE_SEND_OTP_ENDPOINT,
  REFRESH_URL: import.meta.env.VITE_API_REFRESH_URL,
  TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY,
  TURNSTILE_SCRIPT_URL: import.meta.env.VITE_TURNSTILE_SCRIPT_URL || 
    "https://challenges.cloudflare.com/turnstile/v0/api.js",

  // Timeout configurations (with defaults)
  API_TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 15000,
  AUTH_TIMEOUT: Number(import.meta.env.VITE_AUTH_TIMEOUT) || 10000,
  REFRESH_TIMEOUT: Number(import.meta.env.VITE_REFRESH_TIMEOUT) || 5000,
};

// API endpoints (consolidated from endpoints.ts)
export const API = {
  LOGIN: `${ENV.AUTH_BASE_URL}${ENV.LOGIN_ENDPOINT}`,
  FORGOT_PASSWORD: `${ENV.AUTH_BASE_URL}${ENV.FORGOT_PASSWORD_ENDPOINT}`,
  RESET_PASSWORD: `${ENV.AUTH_BASE_URL}${ENV.RESET_PASSWORD_ENDPOINT}`,
  UPDATE_PASSWORD: `${ENV.AUTH_BASE_URL}${ENV.UPDATE_PASSWORD_ENDPOINT}`,
  VERIFY_OTP: `${ENV.OTP_BASE_URL}${ENV.VERIFY_OTP_ENDPOINT}`,
  RESEND_OTP: `${ENV.OTP_BASE_URL}${ENV.RESEND_OTP_ENDPOINT}`,
  SEND_OTP: `${ENV.OTP_BASE_URL}${ENV.SEND_OTP_ENDPOINT}`,
  REFRESH: ENV.REFRESH_URL,
  ME: '/auth/me',
  CREATE_ISO: `${ENV.AUTH_BASE_URL}/createIso`,
  GET_USERS: `${ENV.AUTH_BASE_URL}/getUsers`,
} as const;

// Type definitions for environment variables
export interface EnvConfig {
  API_BASE_URL: string;
  API_BASE_URL_SANDBOX: string;
  API_BASE_URL_PRODUCTION: string;
  AUTH_BASE_URL: string;
  COMPANY_API_URL_SANDBOX: string;
  COMPANY_API_URL_PRODUCTION: string;
  LOGIN_ENDPOINT: string;
  FORGOT_PASSWORD_ENDPOINT: string;
  RESET_PASSWORD_ENDPOINT: string;
  UPDATE_PASSWORD_ENDPOINT: string;
  REFRESH_URL: string;
  TURNSTILE_SITE_KEY: string;
  TURNSTILE_SCRIPT_URL: string;
  API_TIMEOUT: number;
  AUTH_TIMEOUT: number;
  REFRESH_TIMEOUT: number;
}
